import { Injectable } from '@angular/core';
import { linkToGlobalState } from '@helpers/redux-devtools.helper';
import { CustomerSettingsI } from '@interfaces/customer-settings.interface';
import { ExtraAccessValidatorResultI } from '@interfaces/extra-access-validator.interface';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

export interface GlobalState {
  queryParams: { [key: string]: string };
  customerSettings?: CustomerSettingsI;
  globalPersmissionsOverrides?: ExtraAccessValidatorResultI[];
  isDialerOpen?: boolean;
  goToDialer?: boolean;
  logout?: boolean;
  snipersellOrgId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class GlobalStoreService extends ComponentStore<GlobalState> {
  constructor(private store: Store) {
    super({ queryParams: {} });
    linkToGlobalState(this.state$, 'global-store', this.store);
  }

  public globalPersmissionsOverrides$ = this.select((state) => state.globalPersmissionsOverrides);
  public setGlobalPersmissionsOverrides = this.updater(
    (state, globalPersmissionsOverrides: ExtraAccessValidatorResultI[]) => ({
      ...state,
      globalPersmissionsOverrides,
    })
  );
  public customerSettings$ = this.select((state) => state.customerSettings);
  public setcustomerSettings = this.updater((state, customerSettings: CustomerSettingsI) => ({
    ...state,
    customerSettings,
  }));

  public snipersellOrgId$ = this.select((state) => state.snipersellOrgId);
  public setSnipersellOrgId = this.updater((state, snipersellOrgId: string | null) => ({
    ...state,
    snipersellOrgId,
  }));

  public getSnipersellOrgId(): string | null | undefined {
    return this.get((state) => state.snipersellOrgId);
  }

  public dialerOpen$ = this.select((state) => state.isDialerOpen);

  public setDialerOpen = this.updater((state, isDialerOpen: boolean) => ({
    ...state,
    isDialerOpen,
  }));

  public goToDialer$ = this.select((state) => state.goToDialer);
  public setGoToDialer = this.updater((state, goToDialer: boolean) => ({
    ...state,
    goToDialer,
  }));

  public getQueryParam(key: string): Promise<any> {
    return firstValueFrom(this.select((state) => state.queryParams[key]));
  }

  public async getQueryParams(): Promise<{ [key: string]: string }> {
    return firstValueFrom(this.select((state) => state.queryParams));
  }

  public setQueryParams(queryParams: { [key: string]: string }) {
    this.setState((state) => ({ ...state, queryParams: queryParams }));
  }

  public setLogout(logout: boolean) {
    this.setState((state) => ({ ...state, logout }));
  }

  public getLogout() {
    return this.select((state) => state.logout);
  }
}
